import { api } from "./client";

export interface DeputyRead {
  id: string;
  clinic_id: string;
  principal_user_id: string;
  deputy_user_id: string;
  valid_from: string;
  valid_until: string;
  reason: string | null;
  created_by_user_id: string;
  revoked_at: string | null;
  created_at: string;
}

export interface DeputyCreatePayload {
  principal_user_id: string;
  deputy_user_id: string;
  valid_from: string;
  valid_until: string;
  reason?: string | null;
}

export async function listDeputies(only_active = false): Promise<{ items: DeputyRead[] }> {
  const { data } = await api.get<{ items: DeputyRead[] }>("/deputies", {
    params: { only_active },
  });
  return data;
}

export async function createDeputy(payload: DeputyCreatePayload): Promise<DeputyRead> {
  const { data } = await api.post<DeputyRead>("/deputies", payload);
  return data;
}

export async function revokeDeputy(id: string): Promise<DeputyRead> {
  const { data } = await api.post<DeputyRead>(`/deputies/${id}/revoke`);
  return data;
}
